/* global define BUILD */
import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router/es';
import { connect } from 'react-redux';
import ModalClose from 'components/ModalClose';
import Legal from 'components/Footer/Legal';

const SYSCO_RESTAURANT_SOLUTIONS_LINK = 'https://www.solutions.sysco.com';
const SYSCO_PRIVACY_NOTICE_LINK = 'https://sysco.com/Privacy-Notice.html';
const SYSCO_LIMIT_USAGE_LINK = 'https://urldefense.com/v3/__https:/privacyportal.onetrust.com/webform/6a7eb96f-702a-4b18-a6f3-67bdff91cc97/338eba68-062c-4da3-9e30-cd87d5b8247b__;!!K-0RPh4!7yIUJyiCdWed2bNbop-bn4cdRPmnvOs64X5zt_FsPBTKZUi9ZdbRNPSc2fdIqzXTcxsRB4ysNVdCQl5vTHgM2q24zV5Ucqs$';
const SYSCO_DONOTSELL_LINK = 'https://urldefense.com/v3/__https:/privacyportal.onetrust.com/webform/6a7eb96f-702a-4b18-a6f3-67bdff91cc97/85a666bf-1859-4df0-9bbe-0bd8409f0db8__;!!K-0RPh4!7yIUJyiCdWed2bNbop-bn4cdRPmnvOs64X5zt_FsPBTKZUi9ZdbRNPSc2fdIqzXTcxsRB4ysNVdCQl5vTHgM2q2439ohb2g$';
@connect(state => ({
  auth: state.session,
  user: state.user.get('data'),
}))
export default class Footer extends Component {
  static propTypes = {
    auth: PropTypes.object,
    user: PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      showTermsConditionsModal: false,
    }
    this.handleTermsConditionsModal = this.handleTermsConditionsModal.bind(this);
    this.handleDataPrivacyClick = this.handleDataPrivacyClick.bind(this);
  }

  handleTermsConditionsModal() {
    const { showTermsConditionsModal } = this.state;
    this.setState({ showTermsConditionsModal: !showTermsConditionsModal });
  }

  handleDataPrivacyClick() {
    window.Optanon.ToggleInfoDisplay();
  }

  render() {
    const { auth, user } = this.props;
    const { showTermsConditionsModal } = this.state;
    const authenticated = auth.get('authenticated')||auth.get('adminAuthenticated');
    const currDate = new Date();
    const agreedToLegal = user.get('agreedToLegal');
    if (authenticated && agreedToLegal) {
      return (
        <div className='footer'>

          <div className={'flex flex-end'}>
            <div className={'flex mr-20 mt-10 font-size-13'}>
              <span className="footer-link pointer" onClick={ this.handleDataPrivacyClick } style={ { color: '#008cd2' } } >Do Not Sell or Share My Personal Information</span>
              <div className={'mr-20'}></div>
              <Link target='_blank' to={ SYSCO_LIMIT_USAGE_LINK }>Limit the Use of My Sensitive Personal Information</Link>

            </div>
          </div>
          <div className={'flex justify-between items-center'}>
            <div className='footer-left'>
              <p>&copy; {currDate.getFullYear()} Sysco Restaurant Solutions. All rights reserved.
                <small>build { BUILD.commit } { BUILD.timestamp }</small>
              </p>
            </div>
            <div className='footer-right'>
              <Link to={ SYSCO_RESTAURANT_SOLUTIONS_LINK } target='_blank'> Sysco Restaurant Solutions</Link> | <Link to={ SYSCO_PRIVACY_NOTICE_LINK } target='_blank'>Privacy Notice</Link> | <Link className='pointer' onClick={ this.handleTermsConditionsModal }>Legal</Link>
            </div>
          </div>
          <ModalClose
            open={ showTermsConditionsModal }
            onCloseModal={ this.handleTermsConditionsModal }
            contentComponent={ showTermsConditionsModal ? <Legal headerTitle='Terms and conditions'/> : null }
            bodyClass='modalclose-body-show-default terms-conditions'
          />
        </div>
      );
    }
    return null;
  }
}